import React, { useReducer, useState, useCallback, useEffect, Fragment } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Label,
    Input,
    Button
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { MdAdd, MdDelete } from "react-icons/md";
// helpers
import handleReducer, { textChange, onBlur, fileChange, formData } from "../lib/handleChange";
import toastAlert from "../lib/toastAlert";
import isEmpty from "../lib/isEmpty";
import fileObjectUrl from "../lib/fileOblectURL";

// api
import { editTestimonial } from "../api/admin";
// validation
import { editTestimonialValid } from "../validation/admin.validation";
// components
import ButtonLoader from "../mycomponents/Layout/ButtonLoader";
import FieldError from "../mycomponents/Layout/FieldError";

const initialFormValue = {
    name: "",
    description: "",
    ownerName: "",
    category: "",
    reviewStar: "",
    side: "",
    coverImage: null
};

const TestimonialEdit = () => {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [formValue, setFormValue] = useReducer(handleReducer, initialFormValue);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [loader, setLoader] = useState(false);

    const {
        name,
        description,
        category,
        ownerName,
        reviewStar,
        side,
        coverImage
    } = formValue;

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "name") {
            return textChange(e, setFormValue);
        } else return textChange(e, setFormValue);
    };

    const handleFileChange = (e) => fileChange(e, setFormValue);

    const handleBlur = (e) => {
        const { name } = e.target;
        onBlur(e, setTouched)
    };

    const handleSubmit = useCallback(
        async (e) => {
            e.preventDefault();
            try {
                setLoader(true);
                let jsonData = { ...formValue };
                delete jsonData.id;
                delete jsonData.status;
                delete jsonData.createdAt;
                const data = formData(jsonData);
                const { status: ok, message, errors } = await editTestimonial(data);
                setLoader(false);

                if (ok === true) {
                    toastAlert("success", message, "editTestimonial");
                    setFormValue({ type: "RESET", value: initialFormValue });
                    navigate("/testimonial-list");
                } else if (errors) {
                    setErrors(errors);
                } else if (message) {
                    toastAlert("error", message, "editTestimonial");
                }
            } catch (err) {
                console.log(err, "errrr");
                setLoader(false);
            }
        },
        [formValue, navigate]
    );

    useEffect(() => {
        const { status, errors } = editTestimonialValid(formValue);
        if (!status) setErrors(errors);
        else setErrors({});
    }, [formValue]);

    useEffect(() => {
        if (!isEmpty(state)) setFormValue({ type: 'INITIAL_SET', value: state })
    }, [state]);

    // console.log(formValue, 'formValueformValue')
    // console.log(errors, 'errorserrorserrors')
    // console.log(touched, 'touchedtouchedtouched')
    return (
        <Row>
            <Col xl={12}>
                <Card>
                    <CardHeader>Add Testimonial</CardHeader>
                    <CardBody>
                        <Form>
                            <Row>
                                {/* Left column */}
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Project Name</Label>
                                        <Input
                                            type="text"
                                            name="name"
                                            value={name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter name"
                                        />
                                        <FieldError name="name" touched={touched} errors={errors} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Owner Name</Label>
                                        <Input
                                            type="text"
                                            name="ownerName"
                                            value={ownerName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter owner name"
                                        />
                                        <FieldError name="ownerName" touched={touched} errors={errors} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Category</Label>
                                        <Input
                                            type="text"
                                            name="category"
                                            value={category}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter category"
                                        />
                                        <FieldError name="category" touched={touched} errors={errors} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Review Star</Label>
                                        <Input
                                            type="number"
                                            name="reviewStar"
                                            value={reviewStar}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter review star"
                                            min={1}
                                            max={5}
                                        />
                                        <FieldError name="reviewStar" touched={touched} errors={errors} />
                                    </FormGroup>

                                </Col>

                                {/* Right column */}
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Description</Label>
                                        <Input
                                            type="textarea"
                                            name="description"
                                            value={description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Description"
                                            rows={4}
                                        />
                                        <FieldError
                                            name="description"
                                            touched={touched}
                                            errors={errors}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Scroll Side</Label>
                                        <Input
                                            type="select"
                                            name="side"
                                            value={side}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value={""} >Select Side</option>
                                            <option value={"left"}>Left</option>
                                            <option value={"right"}>Right</option>
                                        </Input>
                                        <FieldError
                                            name="side"
                                            touched={touched}
                                            errors={errors}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Cover Image</Label>
                                        <Input
                                            type="file"
                                            name="coverImage"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            onBlur={handleBlur}
                                        />
                                        {
                                            coverImage && (
                                                <img
                                                    src={fileObjectUrl(coverImage)}
                                                    width="140px"
                                                    alt="preview"
                                                    className="mt-2"
                                                />
                                            )
                                        }
                                        <FieldError name="coverImage" touched={touched} errors={errors} />
                                    </FormGroup>
                                    ⚠️ Note: Allowed formats: JPG, JPEG, WEBP, PNG. Max size: 5MB.
                                </Col>
                            </Row>
                            <ButtonLoader
                                loader={loader}
                                color="primary"
                                text="Submit"
                                onClick={handleSubmit}
                                disabled={!isEmpty(errors)}
                            />
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </Row >
    );
};

export default TestimonialEdit;